/* ORION: on the refreshed mattress page a link to a place on the same page (the rating to the reviews, the construction
   tile to the layers) glides there instead of jumping: an eased scroll, longer for a longer way, landing where the
   browser would land (the target's scroll-margin-top). A touch, the wheel, a click or a key hands the page back at once.
   By the owner's rule it glides also when the system asks for reduced motion. */
(() => {
  const STOPS = ['wheel', 'touchstart', 'mousedown', 'keydown'];
  const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  let run = 0;

  function glide(target) {
    const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
    const from = window.scrollY;
    const end = document.documentElement.scrollHeight - innerHeight;
    const to = Math.max(0, Math.min(end, target.getBoundingClientRect().top + from - margin));
    const distance = to - from;
    if (Math.abs(distance) < 2) return Promise.resolve();
    const duration = Math.min(1200, Math.max(600, Math.abs(distance) * 0.45));
    const id = ++run;
    const start = performance.now();
    return new Promise((resolve) => {
      const done = () => { STOPS.forEach((type) => removeEventListener(type, stop)); resolve(); };
      const stop = () => { run += 1; done(); };
      STOPS.forEach((type) => addEventListener(type, stop, { passive: true }));
      const frame = (now) => {
        if (id !== run) return;
        const t = Math.min(1, (now - start) / duration);
        window.scrollTo({ top: from + distance * ease(t), behavior: 'instant' });
        if (t < 1) requestAnimationFrame(frame);
        else done();
      };
      requestAnimationFrame(frame);
    });
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!link.closest('.orion-mattress-product--refresh')) return;
    const id = decodeURIComponent(link.getAttribute('href').slice(1));
    const target = id ? document.getElementById(id) : null;
    if (!target) return;
    event.preventDefault();
    history.pushState(null, '', `#${id}`);
    // A second, short glide lands it exactly if the page moved on the way (a picture above it that loaded).
    glide(target).then(() => glide(target)).then(() => { if (target.hasAttribute('tabindex')) target.focus({ preventScroll: true }); });
  });
})();
